// eslint-disable-next-line no-restricted-syntax
enum PasswordRequirements {
  PASSWORD_LENGTH = 'signUp.password.requirements.minLength',
  PASSWORD_NUMBER = 'signUp.password.requirements.number',
  PASSWORD_LOWERCASE = 'signUp.password.requirements.lowercase',
  PASSWORD_UPPERCASE = 'signUp.password.requirements.uppercase',
  PASSWORD_SPECIAL_CHAR = 'signUp.password.requirements.specialChar',
  PASSWORD_MATCH = 'signUp.password.requirements.match',
}

export const passwordRequirements = [
  { isValid: false, re: /^.{8,}$/, label: PasswordRequirements.PASSWORD_LENGTH },
  { isValid: false, re: /[0-9]/, label: PasswordRequirements.PASSWORD_NUMBER },
  { isValid: false, re: /[a-z]/, label: PasswordRequirements.PASSWORD_LOWERCASE },
  { isValid: false, re: /[A-Z]/, label: PasswordRequirements.PASSWORD_UPPERCASE },
  {
    isValid: false,
    re: /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/,
    label: PasswordRequirements.PASSWORD_SPECIAL_CHAR,
  },
];

export const getPasswordMatchRequirement = (password: string, confirmPassword: string) => ({
  isValid: password === confirmPassword && password.length > 0,
  re: undefined,
  label: PasswordRequirements.PASSWORD_MATCH,
});
